/**
 * 编辑器画布布局：直接复用运行时的纯函数，保证所见即所得。
 * 画布本身不缩放（zoom 由外层 transform 处理），所以 viewport 以设计尺寸构造。
 */
import { CANVAS_HEIGHT, CANVAS_WIDTH, type Layer, type PageMode } from '@h5/schema';
import { computeViewport, layerToStyle as runtimeLayerToStyle, type Viewport as RuntimeViewport } from '@h5/runtime/layout';
import type { CSSProperties } from 'react';

export interface Viewport extends RuntimeViewport {
  mode: PageMode;
}

/** 编辑器画布的 viewport：fixed 页屏幕即设计稿（diff = 0），long 页取内容高度。 */
export function designViewport(mode: PageMode, height = CANVAS_HEIGHT): Viewport {
  const vh = mode === 'fixed' ? CANVAS_HEIGHT : Math.max(height, CANVAS_HEIGHT);
  return { ...computeViewport({ vw: CANVAS_WIDTH, vh }), mode };
}

export function layerToStyle(layer: Layer, viewport: Viewport): CSSProperties {
  const s = runtimeLayerToStyle(layer, viewport, viewport.mode);
  return {
    position: 'absolute',
    left: s.left,
    top: s.top,
    width: s.width,
    height: s.height,
    transform: s.transform === 'none' ? undefined : s.transform,
    opacity: s.opacity,
    zIndex: s.zIndex,
    display: layer.hidden ? 'none' : undefined,
  };
}
